module.exports = __webpack_public_path__ + "img/default-bg-in.cc9a2168.png";